<template>
  <button 
    class="pa-2 rounded-lg elevation-3 d-flex flex-column align-center"
    :class="disabled ? disabledClasses : enabledClasses"
    style="max-width: 95px"
    :disabled="disabled"
    v-bind="$attrs"
    @click="(e) => $emit('click', e)"
  >
    <v-icon :color="disabled ? 'grey' : 'white'" x-large>{{ icon }}</v-icon>
    <div 
      class="text-center" 
      style="font-size: 10px; text-transform: uppercase; line-height: 1.1;"
    >
      {{ message }}
    </div>
  </button>
</template>

<script>
export default {
  name: 'SquareButton',

  props: {
    disabled: Boolean,
    icon: String,
    message: String,
  },

  data() {
    return {
      enabledClasses: {
        primary: true,
        'white--text': true,
      },

      disabledClasses: {
        grey: true,
        'lighten-2': true,
        'grey--text': true,
      },
    }
  },
}
</script>